import { useEffect, useRef } from "react";

export default function useDebounce(effect, dependencies, delay) {
  const effectRef = useRef(effect);
  effectRef.current = effect;
  useEffect(() => {
    const timeout = setTimeout(() => effectRef.current(), delay);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- delay + caller-provided dependencies array (spread cannot be verified statically)
  }, [delay, ...dependencies]);
}
